import React, { Component } from 'react';
import {connect} from 'react-redux';
import {  emptyDemoSubQuestionResponse, getSubQuesDataById, updatesubQuestion, getSubQuesOptionsById, softDeleteSubOption} from '../../actions/demographics';
import EditSubQuestion from '../../components/demographics/editSubQuestion';

class EditDemographicsSubQuestion extends Component {
  constructor(props){
    super(props)

    this.queryString = window.location.href;

    if (this.queryString !== "") {
        this.sub_ques_id = this.queryString.split("&sq:")[1];  
    }

    this.state={
        editCategoryPageData : "",
        sub_ques_id : this.sub_ques_id
    };

    this.emptyDemoSubQuestionResponse = this.emptyDemoSubQuestionResponse.bind(this);
    this.updatesubQuestion = this.updatesubQuestion.bind(this);
    this.softDeleteSubOption = this.softDeleteSubOption.bind(this);
    this.gotoSecondSubquestionView = this.gotoSecondSubquestionView.bind(this);
  }

 

  componentDidMount(){
    if(this.state.sub_ques_id){
       this.props.dispatch(getSubQuesDataById(this.state.sub_ques_id));
       this.props.dispatch(getSubQuesOptionsById(this.state.sub_ques_id));
    }
  }

  emptyDemoSubQuestionResponse(){
      this.props.dispatch(emptyDemoSubQuestionResponse());
  }

  updatesubQuestion(data){
  this.props.dispatch(updatesubQuestion(data));
  }

  softDeleteSubOption(data){
    this.props.dispatch(softDeleteSubOption(data));
  }

  gotoSecondSubquestionView(catId, quesId, subQuesId){
    this.props.history.push('/demoSecSubQuestion/&c:'+ catId+'/&q:'+quesId+'/&sq:'+subQuesId);
  }
  
  render(){

   
    let showEditDemographicsCategoriesSubQuestionView ="";
    if(this.props.showDemoGraphicsEditSubQuestion){
         showEditDemographicsCategoriesSubQuestionView = <EditSubQuestion
        demoGraphicsEditSubQuestionSuccess = {this.props.demoGraphicsEditSubQuestionSuccess}
        demoGraphicsEditSubQuestionData = {this.props.demoGraphicsEditSubQuestionData}
        updatesubQuestion = {this.updatesubQuestion}
        subQuestionUpdateSuccess = {this.props.subQuestionUpdateSuccess}
        subQuestionUpdateSuccessMessage = {this.props.subQuestionUpdateSuccessMessage}
        subQuestionUpdateFailMessage = {this.props.subQuestionUpdateFailMessage}

        emptyDemoSubQuestionResponse = {this.emptyDemoSubQuestionResponse}

        demoGraphicsCatSubQuesOptionsListSuccess = {this.props.demoGraphicsCatSubQuesOptionsListSuccess}
        demoGraphicsCatSubQuesOptionsListData = {this.props.demoGraphicsCatSubQuesOptionsListData}

        softDeleteSubOption = {this.softDeleteSubOption}

        gotoSecondSubquestionView = {this.gotoSecondSubquestionView}
    />
    }
    
      
    return (
        <div> 
             {showEditDemographicsCategoriesSubQuestionView}
        </div>
    );
  }
}

const  mapStateToProps =(state) =>{
  return {
    showDemoGraphicsEditSubQuestion    : state.demographics.showDemoGraphicsEditSubQuestion,
    demoGraphicsEditSubQuestionSuccess : state.demographics.demoGraphicsEditSubQuestionSuccess,
    demoGraphicsEditSubQuestionData    : state.demographics.demoGraphicsEditSubQuestionData,
    subQuestionUpdateSuccess : state.demographics.subQuestionUpdateSuccess,
    subQuestionUpdateSuccessMessage : state.demographics.subQuestionUpdateSuccessMessage,
    subQuestionUpdateFailMessage : state.demographics.subQuestionUpdateFailMessage,

    demoGraphicsCatSubQuesOptionsListSuccess : state.demographics.demoGraphicsCatSubQuesOptionsListSuccess,
    demoGraphicsCatSubQuesOptionsListData : state.demographics.demoGraphicsCatSubQuesOptionsListData,
  }
}

export default connect(mapStateToProps)(EditDemographicsSubQuestion);



// WEBPACK FOOTER //
// ./src/pages/demographics/editDemoSubQuestion.js